<template>
  <div class="container">
<!--    <h2>行业归类:{{industry}}</h2>-->
<!--    <h2>归类细分:{{subCategory}}</h2>-->
    <h2>店铺名称:{{shopName}}</h2>

    <!-- 平台选择 -->
    <div>
      <label for="platform">消费者平台:</label>
      <select id="platform" v-model="platform" required>
        <option>美团</option>
        <option>阿里巴巴</option>
        <option>京东</option>
        <option>其他</option>
      </select>
    </div>

    <!-- 星级评分 -->
    <div class="rating-section">
      <div class="rating-row" v-for="(rating, key) in ratings" :key="key">
        <label>{{ key }}:</label>
        <div class="stars">
          <span
              v-for="index in 5"
              :key="index"
              @click="setRating(key, index)"
              class="star "
              :class="{
              full: ratings[key] >= index,
              empty: ratings[key] < index
            }"
          >
            &#9733;
          </span>
        </div>
      </div>
    </div>

    <!-- 评价文本 -->
    <div>
      <label for="review">评价内容:</label>
      <textarea id="review" v-model="review" rows="4" placeholder="请输入评价..."></textarea>
    </div>

    <!-- 标签选择 -->
    <div class="tags-section">
      <label>建议:</label>
      <div class="tags">
        <div
            class="tag"
            v-for="(tag, index) in tags"
            :key="index"
            :class="{ selected: selectedTags.includes(tag) }"
            @click="toggleTag(tag)"
        >
          {{ tag }}
        </div>
      </div>
    </div>

    <!-- 按钮 -->
    <div class="buttons">
      <button @click="generateReview">生成评价</button>
      <button @click="clearReview">清除评价</button>
      <button @click="copyToClipboard">复制到剪贴板</button>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue';
import { useRoute } from 'vue-router';
import api from '../api';

export default {
  setup() {
    const route = useRoute();
    const industry = ref(route.query.industry || '');
    const subCategory = ref(route.query.subCategory || '');
    const shopName = ref(route.query.shopName || '');

    const platform = ref('');
    const review = ref('');
    const selectedTags = ref([]);
    const ratings = reactive({
      总体: 5,
      味道: 5,
      环境: 5,
      服务: 5,
    });
    const tags = [
      '大份量', '新鲜食材', '口味丰富', '实惠',
      '美味', '香气四溢', '健康', '菜品多样'
    ];

    const setRating = (key, index) => {
      ratings[key] = index;
    };

    const toggleTag = (tag) => {
      const index = selectedTags.value.indexOf(tag);
      if (index > -1) {
        selectedTags.value.splice(index, 1);
      } else {
        selectedTags.value.push(tag);
      }
    };

    const generateReview = async () => {
      try {
        // 判断评价内容是否为空，选择不同的接口
        const url = review.value === '' ? '/customer/get_reviews' : '/customer/get_reviews_expand';

        const payload = {
          ztpj: ratings.总体,
          kw: ratings.味道,
          hj: ratings.环境,
          fw: ratings.服务,
          ctlx: subCategory.value || null,
          tags: selectedTags.value,
        };

        // 如果评价内容不为空，加入 old_text 参数
        if (review.value !== '') {
          payload.old_text = review.value;
        }

        const response = await api.post(url, payload);
        alert('评价已生成!');

        const data = response.data;
        review.value = data || '';
      } catch (error) {
        console.error('生成评价失败:', error);
        alert('生成评价失败，请重试！');
      }
    };

    const copyToClipboard = () => {
      const tempInput = document.createElement('input');
      tempInput.value = review.value;
      document.body.appendChild(tempInput);
      tempInput.select();
      tempInput.setSelectionRange(0, 99999);
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      alert('评价内容已复制到剪贴板！');
    };

    const clearReview = () => {
      review.value = '';
      // Object.keys(ratings).forEach(key => {
      //   ratings[key] = 0;
      // });
      alert('评价已清除!');
    };

    return {
      shopName,
      industry,
      subCategory,
      platform,
      review,
      selectedTags,
      ratings,
      tags,
      setRating,
      toggleTag,
      generateReview,
      copyToClipboard,
      clearReview,
    };
  }
};
</script>

<style scoped>
/* 全局设置 */
*,
*::before,
*::after {
  box-sizing: border-box;
}

.container {
  width: 100vw;
  max-width: 100%;
  padding: 20px;
  background: #f4faff; /* 浅蓝色背景 */
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: auto;
  font-family: Arial, sans-serif;
}

h2 {
  text-align: center;
  color: #007bff; /* 蓝色标题 */
  font-size: 1.6rem;
  margin-bottom: 20px;
}

label {
  font-size: 1rem;
  color: #333; /* 深色文本 */
  display: block;
  margin-bottom: 5px;
}

select,
textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 1rem;
}

textarea {
  resize: vertical;
  min-height: 100px;
}

.rating-section {
  margin-bottom: 20px;
}

.rating-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stars {
  display: flex;
  cursor: pointer;
}

.star {
  font-size: 20px;
  color: #d0e6ff; /* 浅蓝色未选中状态 */
}

.star.full {
  color: #007bff; /* 蓝色选中状态 */
}

.star.empty {
  color: #d0e6ff;
}

.tags-section {
  margin-bottom: 20px;
}

.tags {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 10px;
  white-space: nowrap;
}

.tags::-webkit-scrollbar {
  height: 8px;
}

.tags::-webkit-scrollbar-thumb {
  background-color: #b3d1ff; /* 浅蓝色滚动条 */
  border-radius: 4px;
}

.tags::-webkit-scrollbar-thumb:hover {
  background-color: #80bfff; /* 滚动条悬停时的深蓝色 */
}

.tag {
  padding: 6px 12px;
  background-color: #e6f2ff; /* 浅蓝色标签背景 */
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.tag.selected {
  background-color: #007bff; /* 深蓝色选中标签 */
  color: white;
}

.buttons button {
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background-color: #409eff; /* 蓝色按钮 */
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.buttons button:hover {
  background-color: #007bff; /* 深蓝色按钮悬停 */
}

/* 小屏幕适配 */
@media (max-width: 480px) {
  .container {
    padding: 15px;
  }

  h2 {
    font-size: 1.4rem;
  }

  .star {
    font-size: 18px;
  }

  .tag {
    padding: 4px 10px;
    font-size: 0.9rem;
  }

  .buttons button {
    font-size: 0.9rem;
    padding: 8px;
  }
}
</style>
